<template>
  <div class="ohs-request-display">
    <div class="card card-default mb-4">
      <h4
        class="card-header">
        <span v-html="title"></span>
        <span class="badge float-right" :class="label"> {{trades.reportCode}} </span>
      </h4>
      <div class="card-body">
        <p 
          class="text-danger"
          v-if="!trades.complete">
          <i class="fa fa-exclamation-triangle" /> Report Incomplete
        </p>
        <h5 v-if="trades.contractorCompany">
          <span class="badge" :class="label"> {{trades.reportCode}} </span> - {{ trades.contractorCompany }}
        </h5>
        <p class="text-muted" v-if="trades.StaffMember">
          {{ trades.StaffMember.fullName }} - <i class="far fa-clock fa-fw" /> {{ trades.createdAt | date_time_format }}
          <span class="float-right" v-if="$user.administrator"><i class="fas fa-stopwatch fa-fw" /> Time spent: {{ timeSpent }}</span>
        </p>
        <template v-if="trades.TaxInvoiceRequest">
          <p>
            <strong>
              Tax Invoice Request
            </strong>
            <br>
            <download-input
              :options="{ label: trades.TaxInvoiceRequest.referenceNumber, permalink: 'downloadFile'}"
              :value="{ objectKey: trades.TaxInvoiceRequest.InvoiceRequestPdf.objectKey }" />
          </p>
          <p v-if="trades.TaxInvoiceRequest.UploadedInvoice">
            <strong>
              Uploaded Invoice
            </strong>
            <br>
            <download-input
              :options="{ label: trades.TaxInvoiceRequest.UploadedInvoice.fileName, permalink: 'downloadFile'}"
              :value="{ objectKey: trades.TaxInvoiceRequest.UploadedInvoice.objectKey }" />
          </p>
        </template>
        <template v-if="trades.SentEmails.length">
          <sent-email
            v-for="email in trades.SentEmails"
            :key="email.uuid"
            :email="email">
          </sent-email>
        </template>
      </div>
      <div class="card-footer">
        <router-link
          :to="{ path: 'edit/' + trades.uuid, append: true }"
          class="my-1 btn btn-black">
          <i class="far fa-fw fa-edit" /> Edit
        </router-link>
        <router-link
          target="_blank"
          :to="{ path: '/api/public/pdf/' + trades.uuid + '?m=TradesReport' }"
          class="my-1 btn btn-secondary"
          :class="{ 'disabled': !trades.ReportPdfUuid }">
          <i class="fa fa-fw fa-search" /> Preview
        </router-link>
        <download-input
          :disabled="!trades.ReportPdfUuid"
          :options="{ button: true, permalink: 'downloadFile'}"
          :value="{ objectKey: trades.ReportPdf ? trades.ReportPdf.objectKey : '' }" />
        <button 
          class="my-1 btn btn-primary" 
          @click="generatePdf()">
          <i class="fa fa-fw fa-redo-alt" /> Generate PDF
        </button>
        <button 
          class="my-1 btn btn-info"
          @click="upload()">
          <i class="fa fa-fw fa-upload" /> Upload
        </button>
        <button 
          class="my-1 btn btn-success" 
          @click="send()" 
          :disabled="!trades.complete">
          <i class="far fa-fw fa-paper-plane" /> Send
        </button>
        <button 
          v-if="trades.type !== 'Work Order'"
          class="my-1 btn btn-lime" 
          @click="convertToWorkOrder()">
          <i class="fa fa-fw fa-exchange-alt" /> Convert to Work Order
        </button>
        <router-link 
          :to="'/tax-invoice-requests/new/' + trades.uuid + '?t=Trades'"
          class="my-1 btn btn-warning"
          :class="{ 'disabled': !generateInvoiceButton }">
          <i class="fa fa-fw fa-dollar-sign" /> Invoice Request
        </router-link>
        <button 
          @click="deleteTradesReport()" 
          class="my-1 btn btn-danger">
          <i class="fa fa-fw fa-trash" /> Delete
        </button>
      </div>
    </div>
  </div>
</template>
<script>
  import {
    DELETE_REPORT,
    CONVERT_TRADES_REPORT,
    GENERATE_TRADES_PDF,
    SEND_TRADES_REPORT,
    UPLOAD_TRADES_REPORT
  } from '@/vuex/types'
  import SentEmail from '@/components/displays/SentEmail'
  import DownloadInput from '@/components/inputs/DownloadInput'
  export default {
    name: 'TradesReportDisplay',
    props: {
      object: {
        type: Object,
        default () {
          return {}
        }
      }
    },
    components: {
      SentEmail,
      DownloadInput
    },
    computed: {
      timeSpent () {
        let minutes = this.trades.time / 60.0
        if (minutes > 120) {
          let hours = minutes / 60
          return hours.toFixed(2) + ' hours'
        } else {
          return minutes.toFixed(2) + ' min'
        }
      },
      fileName () {
        if (this.trades.ReportPdf) {
          return this.trades.ReportPdf.fileName.slice(0, -4)
        } else {
          return this.trades.propertyAddress
        }
      },
      label () {
        if (this.trades.type === 'Work Order') {
          return 'badge-info'
        } else {
          return 'badge-dark'
        }
      },
      generateInvoiceButton () {
        return this.trades.complete && !this.trades.TaxInvoiceRequestUuid
      },
      title () {
        if (this.trades.propertyAddress) {
          return '<i class="fa fa-fw fa-map-marker-alt"></i> ' + this.trades.propertyAddress
        } else {
          return '<i class="fa fa-fw fa-certificate"></i> New ' + this.trades.type
        }
      },
      trades () {
        return {
          StaffMember: {},
          ...this.object
        }
      }
    },
    methods: {
      async deleteTradesReport () {
        await this.$store.dispatch(DELETE_REPORT, {
          reportUuid: this.trades.uuid,
          reportType: 'TradesReport'
        })
      },
      async generatePdf () {
        await this.$store.dispatch(GENERATE_TRADES_PDF, this.trades)
      },
      async convertToWorkOrder () {
        await this.$store.dispatch(CONVERT_TRADES_REPORT, this.trades.uuid)
      },
      async send () {
        await this.$store.dispatch(SEND_TRADES_REPORT, this.trades.uuid)
      },
      async upload () {
        await this.$store.dispatch(UPLOAD_TRADES_REPORT, this.trades.uuid)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/cards/Trades.vue